module.exports = __webpack_public_path__ + "style/img/平台能力：数据平台技术架构.1f71d3e0.png";